import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminHeaderComponent } from '../../shared/widgets/admin-header/admin-header.component';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { Store } from '@ngrx/store';
import { AppState } from '../../core/store';
import { takeUntil } from 'rxjs';
import { getSettingsStore } from '../../core/store/selectors/settings.selectors';
import { AdminSidemenuComponent } from '../../shared/widgets/admin-sidemenu/admin-sidemenu.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Unsub } from '../../core/services/unsub.class';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NzLayoutModule,
    AdminHeaderComponent,
    AdminSidemenuComponent,
    NzToolTipModule,
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css',
})
export class AdminLayoutComponent extends Unsub implements OnInit, OnDestroy {
  store = inject(Store<AppState>);

  isCollapsed = true;

  ngOnInit(): void {
    this.store
      .select(getSettingsStore)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((settingsStore) => {
        this.isCollapsed = settingsStore.sideMenuCollapsedState;
      });
  }
}
